import { shallowRef } from 'vue'

export type PageHeaderActionItem = {
  id: string
  label: string
  icon?: any
  variant?: 'default' | 'outline' | 'secondary' | 'ghost'
  primary?: boolean
  section?: string
  disabled?: boolean
  action: () => unknown | Promise<unknown>
}

const pageHeaderActionsState = shallowRef<PageHeaderActionItem[]>([])

export function usePageHeaderActions() {
  return pageHeaderActionsState
}

export function resetPageHeaderActions() {
  pageHeaderActionsState.value = []
}
